import HcSticky from 'hc-sticky'
import log from 'salvo-lite/log'
class Sticky {
    constructor (theme, elem) {
        this._elem = elem
        this._options = {
            top: 0,
            bottomEnd: 0,
            innerTop: 0,
            followScroll: false,
            desktopOnly: false,
            header: false,
            stickTo: elem.closest('.sticky-container') || elem.parentNode,
            ...JSON.parse(elem.dataset.sticky)
        }
        this._stickyOptions = ''
        if (this._options.desktopOnly) {
            this._options.responsive = {
                1024: {
                    disable: true
                }
            }
        }
        if (this._options.header) {
            const headerHeight = document.querySelector('header').offsetHeight
            this._options.top = headerHeight
        }
    }

    onInit () {
        let Sticky = new HcSticky(this._elem, this._options)
        log.debug(this.constructor.name, 'Initiated', Sticky)
        if (this._options.header) {
            window.addEventListener('resize', e => {
                Sticky.update({
                    top: document.querySelector('header').offsetHeight
                })
            })
        }
    }
}
export default Sticky



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Sticky.js